import api from '../index';
import { isSuccessApiStatusCode } from "@/api/handler";
import { IEImzoEncryptedDData } from "@/mixins/e-imzo/interface";
import { getURLSearchParamsByObj } from "@/api/other-request-handler";
import { IGetServerToken, ISendCrkErrorData } from "@/api/e-imzo/interface";
import { DigitalSignCommonData } from '@/mixins/crk/interface';

export const $checkEImzoSignature = (v: IEImzoEncryptedDData): Promise<boolean> => api
	.post('e-imzo/upload', getURLSearchParamsByObj(v), {
		handler: {
			returnData: false
		},
		request: {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		}
	})
	.then(r => r ? isSuccessApiStatusCode(r.status) : false);


export const $postSendCrkSumPayment = (type: string, v: DigitalSignCommonData): Promise<any> => api
	.post(type + "/sign-save", v, {
		handler: {
			returnData: false,
			dontShowErrorMessage: true,
		},
	});

export const $postSendCrkSumPaymentNew = (type: string, v: DigitalSignCommonData): Promise<any> => api
	.post(type + "/approve", v, {
		handler: {
			returnData: false,
			dontShowErrorMessage: true,
		},
	});

export const $SendCrkRegisterToBank = (type: string, v: DigitalSignCommonData, idempotencyKey?: string): Promise<any> => api
	.post("payment-order/" + type + "/sign-save", v, {
		handler: {
			returnData: false,
			dontShowErrorMessage: true,
		},
		request: {
			headers: idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : {},
		},
	});

export const $getTokenCrkByPayment = async (): Promise<IGetServerToken> => {
	return api
		.get("isigner/get-isigner-token", {
			handler: { skipSessionExpired: true }
		})
		.then(r => r || null);
};

export const $postCrkErrorMessage = (v: ISendCrkErrorData): Promise<any> => api
	.post("payment-order/write-error", v, {
		handler: { skipSessionExpired: true }
	});
